import { defineMessages } from "react-intl"

export default defineMessages({
  headerMobileTesting: {
    id: "app.components.MobileTesting.headerMobileTesting",
  },
  mobileTesting: {
    id: "app.components.MobileTesting.mobileTesting",
  },
  playFrequencies: {
    id: "app.components.MobileTesting.playFrequencies",
  },
  "playFrequencies.MultipleTimesADay": {
    id: "app.components.MobileTesting.playFrequencies.MultipleTimesADay",
  },
  "playFrequencies.OnceADay": {
    id: "app.components.MobileTesting.playFrequencies.OnceADay",
  },
  "playFrequencies.SeveralTimesPerWeek": {
    id: "app.components.MobileTesting.playFrequencies.SeveralTimesPerWeek",
  },
  "playFrequencies.OncePerWeek": {
    id: "app.components.MobileTesting.playFrequencies.OncePerWeek",
  },
  "playFrequencies.SeveralTimesPerMonth": {
    id: "app.components.MobileTesting.playFrequencies.SeveralTimesPerMonth",
  },
  "playFrequencies.OncePerMonth": {
    id: "app.components.MobileTesting.playFrequencies.OncePerMonth",
  },
  sessionPlaytimes: {
    id: "app.components.MobileTesting.sessionPlaytimes",
  },
  "sessionPlaytimes.3+hours": {
    id: "app.components.MobileTesting.sessionPlaytimes.3+hours",
  },
  "sessionPlaytimes.1-3hours": {
    id: "app.components.MobileTesting.sessionPlaytimes.1-3hours",
  },
  "sessionPlaytimes.30minutes-1Hour": {
    id: "app.components.MobileTesting.sessionPlaytimes.30minutes-1Hour",
  },
  "sessionPlaytimes.10-30Minutes": {
    id: "app.components.MobileTesting.sessionPlaytimes.10-30Minutes",
  },
  "sessionPlaytimes.LessThan10minutes": {
    id: "app.components.MobileTesting.sessionPlaytimes.LessThan10minutes",
  },
  playLocations: {
    id: "app.components.MobileTesting.playLocations",
  },
  "playLocations.Home": {
    id: "app.components.MobileTesting.playLocations.Home",
  },
  "playLocations.Commute": {
    id: "app.components.MobileTesting.playLocations.Commute",
  },
  "playLocations.WorkOrSchool": {
    id: "app.components.MobileTesting.playLocations.WorkOrSchool",
  },
  "playLocations.Bathroom": {
    id: "app.components.MobileTesting.playLocations.Bathroom",
  },
  "playLocations.Other": {
    id: "app.components.MobileTesting.playLocations.Other",
  },
  gamingGenres: {
    id: "app.components.MobileTesting.gamingGenres",
  },
  "gamingGenres.Strategy": {
    id: "app.components.MobileTesting.gamingGenres.Strategy",
  },
  "gamingGenres.Management": {
    id: "app.components.MobileTesting.gamingGenres.Management",
  },
  "gamingGenres.Runner": {
    id: "app.components.MobileTesting.gamingGenres.Runner",
  },
  "gamingGenres.Arcade": {
    id: "app.components.MobileTesting.gamingGenres.Arcade",
  },
  "gamingGenres.Adventure&RPG": {
    id: "app.components.MobileTesting.gamingGenres.Adventure&RPG",
  },
  "gamingGenres.Shooters": {
    id: "app.components.MobileTesting.gamingGenres.Shooters",
  },
  "gamingGenres.HiddenObject": {
    id: "app.components.MobileTesting.gamingGenres.HiddenObject",
  },
  "gamingGenres.Puzzle": {
    id: "app.components.MobileTesting.gamingGenres.Puzzle",
  },
  "gamingGenres.Racing": {
    id: "app.components.MobileTesting.gamingGenres.Racing",
  },
  "gamingGenres.Multiplayer": {
    id: "app.components.MobileTesting.gamingGenres.Multiplayer",
  },
  "gamingGenres.CardGames": {
    id: "app.components.MobileTesting.gamingGenres.CardGames",
  },
  "gamingGenres.Location-based": {
    id: "app.components.MobileTesting.gamingGenres.Location-based",
  },
  "gamingGenres.BattleRoyale": {
    id: "app.components.MobileTesting.gamingGenres.BattleRoyale",
  },
  "gamingGenres.AutoChess": {
    id: "app.components.MobileTesting.gamingGenres.AutoChess",
  },
  "gamingGenres.BrainGames": {
    id: "app.components.MobileTesting.gamingGenres.BrainGames",
  },
  "gamingGenres.CasinoGames": {
    id: "app.components.MobileTesting.gamingGenres.CasinoGames",
  },
  "gamingGenres.CollectibleBattleGames": {
    id: "app.components.MobileTesting.gamingGenres.CollectibleBattleGames",
  },
  "gamingGenres.LifeSimulationGames": {
    id: "app.components.MobileTesting.gamingGenres.LifeSimulationGames",
  },
  "gamingGenres.MMORPG": {
    id: "app.components.MobileTesting.gamingGenres.MMORPG",
  },
  "gamingGenres.MOBA": {
    id: "app.components.MobileTesting.gamingGenres.MOBA",
  },
  "gamingGenres.NarrativeGames": {
    id: "app.components.MobileTesting.gamingGenres.NarrativeGames",
  },
  "gamingGenres.SportGames": {
    id: "app.components.MobileTesting.gamingGenres.SportGames",
  },
  "gamingGenres.SandboxGames": {
    id: "app.components.MobileTesting.gamingGenres.SandboxGames",
  },
  devices: {
    id: "app.components.MobileTesting.devices",
  },
  "devices.AndroidPhone": {
    id: "app.components.MobileTesting.devices.AndroidPhone",
  },
  "devices.AndroidTablet": {
    id: "app.components.MobileTesting.devices.AndroidTablet",
  },
  "devices.iOSPhone": {
    id: "app.components.MobileTesting.devices.iOSPhone",
  },
  "devices.iOSTablet": {
    id: "app.components.MobileTesting.devices.iOSTablet",
  },
  "devices.Other": {
    id: "app.components.MobileTesting.devices.Other",
  },
  peripherals: {
    id: "app.components.MobileTesting.peripherals",
  },
  "peripherals.Controller": {
    id: "app.components.MobileTesting.peripherals.Controller",
  },
  "peripherals.Keyboard": {
    id: "app.components.MobileTesting.peripherals.Keyboard",
  },
  "peripherals.Mouse": {
    id: "app.components.MobileTesting.peripherals.Mouse",
  },
  "peripherals.Other": {
    id: "app.components.MobileTesting.peripherals.Other",
  },



})
